import { EqlFieldName } from '@modules/common/constants';
import { ObjectType } from 'generated/graphql';
import { QuantifyQuery, VisualisationType } from '../store/types';

interface getVisualisationTypesForGroupByFieldParams {
  groupBy: QuantifyQuery['groupBy'];
  measuredAsCriteria: QuantifyQuery['measuredAsCriteria'];
  skipPieChart?: boolean;
  skipTrendChart?: boolean;
}

export function getVisualisationTypesForGroupByField({
  groupBy,
  measuredAsCriteria,
  skipPieChart = false,
  skipTrendChart = false,
}: getVisualisationTypesForGroupByFieldParams): VisualisationType[] {
  const bar = VisualisationType.BAR;
  const trend = skipTrendChart ? null : VisualisationType.TREND;
  const pie = skipPieChart ? null : VisualisationType.PIE;

  if (
    measuredAsCriteria &&
    measuredAsCriteria?.objectType !== ObjectType.Feedback
  ) {
    return [bar];
  }

  function getVisualisations() {
    switch (groupBy?.field) {
      case EqlFieldName.Entity:
        return [bar, trend];
      case EqlFieldName.UserSentiment:
        return [bar, trend, pie];
      case EqlFieldName.Source:
        return [bar, trend, pie];
      default:
        if (!!groupBy?.detail?.metadata) {
          return [bar, trend, pie];
        }

        return [bar, trend];
    }
  }

  const visualisations = getVisualisations();

  return visualisations.filter(
    (visualisation): visualisation is VisualisationType => !!visualisation,
  );
}
